
import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)


 import node from '@/store/node'

 import user from '@/store/user'


export default new Vuex.Store({
    modules:{
        node:node,
        user:user
    }
})